import { useQuery } from '@tanstack/react-query';
import type { AgentMode } from '@tabbio/types';
import { fetchThreadMessages } from '../lib/agent-threads';
import { QUERY_KEYS } from '../lib/query-keys';
import { useWorkspace } from '../providers/useWorkspace';

export function useThreadMessages(
  threadId: string | undefined,
  modeOverride?: AgentMode,
  companyIdOverride?: string,
) {
  const { mode: workspaceMode, companyId: workspaceCompanyId } = useWorkspace();
  const mode = modeOverride ?? workspaceMode;
  const companyId = mode === 'employer' ? (companyIdOverride ?? workspaceCompanyId) : undefined;

  return useQuery({
    queryKey: QUERY_KEYS.THREAD_MESSAGES(threadId!, mode, companyId),
    queryFn: () => fetchThreadMessages(threadId!, mode, companyId),
    enabled: !!threadId,
    staleTime: 2 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
    refetchOnMount: false,
  });
}
